import { MediaListQuery } from "@apps/iloom_customization/design_feed/queries/MediaListQuery";
import { DesignFeedService } from "@apps/iloom_customization/design_feed/services/DesignFeedService";
import { ProductModule } from "@apps/iloom_customization/modules/products/ProductModule";
import { ProductQuery } from "@apps/iloom_customization/modules/products/queries/ProductQuery";
import { ProductService } from "@apps/iloom_customization/modules/products/services/ProductService";
import { WishlistService } from "@apps/iloom_customization/wishlist/services/WishlistService";
import { WishlistProductStatusesQuery } from "@apps/wishlist/queries/WishlistProductStatusesQuery";
import { WishlistProductStatusesService } from "@apps/wishlist/services/WishlistProductStatusesService";
import { WishlistsService } from "@apps/wishlist/services/WishlistsService";
import { CartModule } from "@modules/cart/CartModule";
import { CartQuery } from "@modules/cart/queries/CartQuery";
import { CartService } from "@modules/cart/services/CartService";
import { container, injectable } from "tsyringe";

import TabsManager from "@components/Tabs/TabsManager";
import { LoggerInterface } from "@interfaces/LoggerInterface";
import { WidgetInterface } from "@interfaces/WidgetInterface";

import DesignFeedProductWidgetComponent from "./DesignFeedProductWidget.svelte";
import { DesignFeedProductWidgetConfigInterface } from "./DesignFeedProductWidgetConfig";

@injectable()
class DesignFeedProductWidget implements WidgetInterface {
    private cartQuery: CartQuery;
    private cartService: CartService;
    private designFeedService: DesignFeedService;
    private mediaListQuery: MediaListQuery;
    private productQuery: ProductQuery;
    private productService: ProductService;
    private tabsManager: TabsManager;
    private wishlistProductStatusesQuery: WishlistProductStatusesQuery;
    private wishlistService: WishlistService;
    private wishlistsService: WishlistsService;

    constructor(
        private readonly config: DesignFeedProductWidgetConfigInterface,
        private readonly logger: LoggerInterface
    ) {
        this.logger.debug("DesignFeedProductWidget is initialized", config);
        this.cartQuery = container.resolve(CartModule).exports.cartQuery;
        this.cartService = container.resolve(CartModule).exports.cartService;
        this.designFeedService = container.resolve(DesignFeedService);
        this.mediaListQuery = container.resolve(MediaListQuery);
        this.productQuery =
            container.resolve(ProductModule).exports.productQuery;
        this.productService =
            container.resolve(ProductModule).exports.productsService;
        this.tabsManager = container.resolve(TabsManager);
        this.wishlistProductStatusesQuery = container.resolve(
            WishlistProductStatusesQuery
        );
        this.wishlistService = container.resolve(WishlistService);
        this.wishlistsService = container.resolve(WishlistsService);
    }

    init(): this {
        const element = this.config.target;
        element.style.display = "block";

        const shadowRoot =
            element.shadowRoot || element.attachShadow({ mode: "open" });

        this.productService.subscribe();

        const wishlistProductStatusesService = container.resolve(
            WishlistProductStatusesService
        );
        wishlistProductStatusesService.subscribe();

        new DesignFeedProductWidgetComponent({
            target: shadowRoot,
            props: {
                cartQuery: this.cartQuery,
                cartService: this.cartService,
                designFeedService: this.designFeedService,
                mediaListQuery: this.mediaListQuery,
                productQuery: this.productQuery,
                productService: this.productService,
                tabsManager: this.tabsManager,
                tags: this.config.tags,
                wishlistProductStatusesQuery: this.wishlistProductStatusesQuery,
                wishlistService: this.wishlistService,
                wishlistsService: this.wishlistsService,
            },
        });

        return this;
    }
}

export default DesignFeedProductWidget;
